export default __webpack_public_path__ + "static/media/smileLogo.9343d596.svg";